<div class="consumption-wrapper">
   <!-- Go Back Button -->
   <button class="desp-button" (click)="goHomepage()">Go back to Quantum Emulators</button>
   <!-- Title -->
   <h2 class="consumption-title">My consumption</h2>
   <!-- Main Card -->
   <div class="consumption-container">
      <div class="consumption-card-wrapper">
         <div class="consumption-card-row">
            <!-- Column 1 -->
            <div class="consumption-column">
               <h3>Quota used</h3>
               <ng-container *ngIf="quotaUsed$ | async as quota">
                  <ng-container *ngIf="usage$ | async as usage">
                     <!--  CPU -->
                     <p *ngIf="maxUsage.cpu === 0 || maxUsage.cpu === undefined">CPU: {{ usage.cpu }} vCores</p>
                     <div *ngIf="maxUsage.cpu !== 0 || maxUsage.cpu !== undefined">
                        <p>CPU: {{ quota.cpu.label }} </p>
                        <div class="progress-bar">
                           <div class="progress-bar-fill" [ngStyle]="{ width: quota.cpu.width }"></div>
                        </div>
                        <p class="quota-values">{{ usage.cpu }} / {{ maxUsage.cpu }} vCores</p>
                     </div>
                     <!--  RAM -->
                     <p *ngIf="maxUsage.ram === 0 || maxUsage.ram === undefined">RAM: {{ usage.ram }} GiB</p>
                     <div *ngIf="maxUsage.ram!==0 &&maxUsage.ram !== undefined">
                        <p>RAM: {{ quota.ram.label }}</p>
                        <div class="progress-bar">
                           <div class="progress-bar-fill" [ngStyle]="{ width: quota.ram.width }"></div>
                        </div>
                        <p class="quota-values">{{ usage.ram }} / {{ maxUsage.ram }} GiB</p>
                     </div>
                     <!-- Storage -->
                     <p *ngIf="maxUsage.storage === 0 || maxUsage.storage === undefined">
                        Storage: {{ usage.storage }} GiB
                     </p>
                     <div *ngIf="maxUsage.storage!==0 &&maxUsage.storage !== undefined">
                        <p>Storage: {{ quota.storage.label }}</p>
                        <div class="progress-bar">
                           <div class="progress-bar-fill" [ngStyle]="{ width: quota.storage.width }"></div>
                        </div>
                        <p class="quota-values">{{ usage.storage }} / {{ maxUsage.storage }} GiB</p>
                     </div>
                  </ng-container>
               </ng-container>
            </div>
            <!-- Column 2 -->
            <div class="consumption-column">
               <h3>CPU (vCores)</h3>
               <ng-container *ngIf="usage$ | async as usage">
                  <p>Max value: {{ maxAllowedUsage.cpu }}</p>
                  <div  *ngIf="quotaUsed$ | async as quota">
                  <p *ngIf="quota.cpu.label !== 'Updating...'" >Current value: {{ usage.cpu }}</p>
                  <p *ngIf="quota.cpu.label === 'Updating...'" >Current value: Updating...</p>
                  </div>
                  
               </ng-container>
            </div>
            <!-- Column 3 -->
            <div class="consumption-column">
               <h3>Running Notebooks</h3>
               <ng-container *ngIf="usage$ | async as usage">
                  <!--      no max value for running nb
                     <p>Max value: {{ maxAllowedUsage.notebooks.running }}</p> 
                     -->
                     <div  *ngIf="quotaUsed$ | async as quota">
                       <p *ngIf="quota.cpu.label !== 'Updating...'">Current value: {{ usage.notebooks.running }}</p> 
                       <p *ngIf="quota.cpu.label === 'Updating...'">Current value: Updating...</p>   
                     </div>
                 
               </ng-container>
            </div>
            <!-- Column 4 -->
            <div class="consumption-column">
               <h3>Stopped Notebooks</h3>
               <ng-container *ngIf="usage$ | async as usage">
                  <p>Max value: {{ maxAllowedUsage.notebooks.stopped }}</p>
                  <div  *ngIf="quotaUsed$ | async as quota">
                   <p *ngIf="quota.cpu.label !== 'Updating...'">Current value: {{ usage.notebooks.stopped}}</p>
                   <p *ngIf="quota.cpu.label === 'Updating...'">Current value: Updating...</p>
                  </div>
                  
               </ng-container>
            </div>
         </div>
      </div>
   </div>
</div>